import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button, Header, Icon, Popup } from 'semantic-ui-react';
import useCachedState from 'components/atoms/tables/smarttables/helpers/useCachedState';
import { PopupContainer } from 'components/atoms/tables/smarttables/layout/flex';

const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
`;

const RowRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const ColumnLabel = styled.label`
    text-transform: uppercase;
`;

const ColumnConfiguration = ({ cacheKey, tableProps, isReady = () => null }) => {
    const [columnConfig, setColumnConfig] = useCachedState(`${cacheKey}-table-column-config`, {});
    const { allColumns } = tableProps;
    useEffect(() => {
        if (cacheKey) {
            allColumns.forEach((x) => {
                if (typeof columnConfig[x.id] === 'boolean') {
                    if (columnConfig[x.id] !== x.isVisible) {
                        x.toggleHidden();
                    }
                }
            });
        }
        // gives the table view enough time to now show column flicker from the above toggle.
        setTimeout(() => {
            isReady();
        }, 100);
    }, [columnConfig, cacheKey, allColumns, isReady]);
    const [open, setOpen] = React.useState(false);
    const updateVisible = (target, column, toggleVisiblity) => {
        toggleVisiblity(target);
        if (cacheKey) {
            setColumnConfig({
                ...columnConfig,
                [column.id]: !column.isVisible
            });
        }
    };
    return (
        <Popup
            flowing
            basic
            position='bottom right'
            on='click'
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={<Button style={{
                height: '38px',
                width: '38px',
                backgroundColor: '#FFF',
                boxShadow: '0 1px 2px 0 rgb(34 36 38 / 15%)',
                border: '1px solid rgba(34,36,38,.15)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '18px'
            }} size="big" icon><Icon name="setting"></Icon></Button>}
        >
            <PopupContainer>
                <Header as='h2'>Visible Columns</Header>
                <Column>
                    {allColumns.reduce((toggleableColumns, column) => {
                        if (!column.alwaysHidden) {
                            const columnProps = column.getToggleHiddenProps();
                            const canHide = typeof column.canHide === 'boolean' ? column.canHide : true;
                            toggleableColumns.push(
                                <div key={column.id}>
                                    <ColumnLabel>
                                        <input type="checkbox" disabled={!canHide} {...columnProps} onChange={e => updateVisible(e, column, columnProps.onChange)} />{' '}
                                        {typeof column.Header === 'string' ? column.Header : column.id}
                                    </ColumnLabel>
                                </div>
                            );
                        }

                        return toggleableColumns;
                    }, []
                    )}
                </Column>
                <RowRight>
                    <Button primary onClick={() => setOpen(false)}>Save</Button>
                </RowRight>
            </PopupContainer>
        </Popup>
    );
};

export default ColumnConfiguration;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/tablePlugins/ColumnConfiguration.js